import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type Location, type Coordinates } from '~/utilities';

export interface LocationState {
  value?: Location;
  isWithinSupportedArea?: boolean;
  canUseGeolocation: boolean;
}

export const initialState: LocationState = {
  value: undefined, // Will be set for squamish after feature flags load
  canUseGeolocation: true, // Optimistic default, will be updated after checking
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    clearLocation: (state) => (state.value = undefined),
    setLocation: (state, action: PayloadAction<Location | undefined>) => {
      state.value = action.payload;
    },
    setLocationCoordinates: (state, action: PayloadAction<Coordinates>) => {
      if (state.value) {
        state.value.coordinates = action.payload;
      }
    },
    resetLocation: (state) => {
      state.value = undefined;
    },
    setLocationIsWithinSupportedArea: (
      state,
      action: PayloadAction<boolean | undefined>
    ) => {
      state.isWithinSupportedArea = action.payload;
    },
    setCanUseGeolocation: (state, action: PayloadAction<boolean>) => {
      state.canUseGeolocation = action.payload;
    },
  },
});

type SliceState = { location: LocationState };
export const selectLocation = (state: SliceState) => state.location.value;
export const selectLocationIsSupportedArea = (state: SliceState) =>
  state.location.isWithinSupportedArea !== false;

export const selectHasLocation = (state: SliceState) =>
  !!state.location.value?.coordinates;

export const selectCanUseGeolocation = (state: SliceState) =>
  state.location.canUseGeolocation;

export const {
  clearLocation,
  resetLocation,
  setCanUseGeolocation,
  setLocation,
  setLocationCoordinates,
  setLocationIsWithinSupportedArea,
} = locationSlice.actions;
export default locationSlice.reducer;
